import { useState } from "react";
import { Button, Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { PAGE_SIZE_OPTIONS, DEFAULT_PAGE_SIZE, HIDE_FOOTER_PAGE_SIZE } from "constant";
import "./HadclGrid.css";

export default function HadclGrid({ clearFilter, ...props }) {
	const {
		isClearFilter = true,
		isExport = false,
		height = 400,
		rowHeight = 50,
		columnHeaderHeight = 56,
		onExport,
	} = props;

	const [filterModel, setFilterModel] = useState({ items: [] });
	const [sortModel, setSortModel] = useState([]);

	const clearQueryParams = (e) => {
		setFilterModel({ items: [] });
		setSortModel([]);
	};

	return (
		<>
			{(isClearFilter || isExport) && (
				<div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
					{isExport && (
						<Button variant="text" onClick={onExport}>
							Export
						</Button>
					)}
					{isClearFilter && (
						<Button variant="text" onClick={clearQueryParams}>
							Reset filter
						</Button>
					)}
				</div>
			)}

			<Box style={{ width: "100%", height: height }} className="public-grid">
				<DataGrid
					{...props}
					rows={props.rowData}
					columns={props.columnDefs}
					checkboxSelection={props.checkboxSelection === true}
					rowSelectionModel={props.rowSelectionModel ?? []}
					onRowSelectionModelChange={props.onRowSelectionModelChange}
					disableRowSelectionOnClick
					filterModel={filterModel}
					sortModel={sortModel}
					rowHeight={rowHeight}
					columnHeaderHeight={columnHeaderHeight}
					hideFooter={props?.rowData?.length < HIDE_FOOTER_PAGE_SIZE}
					onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
					onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
					pageSizeOptions={PAGE_SIZE_OPTIONS}
					initialState={{
						pagination: {
							paginationModel: {
								page: 0,
								pageSize: DEFAULT_PAGE_SIZE,
							},
						},
					}}
				/>
			</Box>
		</>
	);
}
